import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { ToxnotServiceClient } from '../../store/ToxnotServiceClient';
import { ToxnotComponent, ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import Layout from '../Layout';

export enum UpsellTypes {
    Pro = "Pro",
    Api = "API",
    Scip = "SCIP"
}

interface OwnProps {
    upsellType: UpsellTypes;
    conversionEvent: string;
    conversionDestinationUrl?: string; // optional, defaults to Subscription page
    renderEmbedded?: boolean; // optional, defaults to false
}

type UpsellComponentProps = ToxnotComponentProperties & OwnProps;

class Upsell extends ToxnotComponent<UpsellComponentProps> {
    public render() {
        const accountUpgradeMessage = this.localizeString("This feature is available with an upgraded 3E Exchange account");

        let heading: string;

        switch (this.props.upsellType) {
            case UpsellTypes.Api:
                heading = accountUpgradeMessage;
                break;
            case UpsellTypes.Scip:
                heading = accountUpgradeMessage;
                break;
            default:
                heading = accountUpgradeMessage;
        }

        let cta: string;

        if (this.props.appServices.userContext?.subscription) {
            cta = this.localizeString("Manage Add-Ons");
        }
        else {
            cta = this.localizeString("View Plans");
        }

        const body = (
            <div className="upsell-with-cta">
                <div className="start-subcontent-heading">
                    {heading}
                </div>
                <p className="start-subcontent-content-container">
                    {this.localizeString("Check out the Subscription page to learn more about plans and add-ons.")}
                </p>
                <p className="start-subcontent-content-container">
                    <button type="button" className="btn btn-tn-action-complement upsell-cta-button" onClick={async e => await this.upsellCtaActionButton_click()}>{cta} <span className="glyphicon glyphicon-chevron-right"></span></button>
                </p>
            </div>
        );

        return (
            (this.props.renderEmbedded ?? false) ?
                body :
                <Layout>
                    <div className="tn-section">
                        <div className="tn-section-row">
                            <div className="tn-section-col-12">
                                {body}
                            </div>
                        </div>
                    </div>
                </Layout>
        );
    }

    // ===============================================================================

    private upsellCtaActionButton_click = async () => {
        const serviceClient = new ToxnotServiceClient();

        await serviceClient.upsellWrite(`upsell-click-${this.props.conversionEvent}`);

        const destinationUrl = this.props.conversionDestinationUrl
            ?? "/Account/Upgrade?plan=pro";

        window.location.href = destinationUrl;
    }
}

// ===============================================================================

export default connect(
    // Selects which state properties are merged into the component's props
    (state: ApplicationState, ownProps: OwnProps) => ({ appServices: state.appServices } )    
)(Upsell as any);
